import { useState } from 'react';
import styles from '@/interface/ui/t/_component/FloatingActionMenu.module.scss';

interface Props {
  onClickLeft: (...args: any) => any;
  onClickLeftTop: (...args: any) => any;
  onClickTop: (...args: any) => any;
}
const FloatingMenu = ({ onClickLeft, onClickLeftTop, onClickTop }: Props) => {
  const [showSubFAB, setShowSubFAB] = useState(false);
  let bgClassName: string;
  let mainButtonClassName: string;
  let subFABLeftClassName: string = styles.subFAB;
  let subFABLeftTopClassName: string = styles.subFAB;
  let subFABTopClassName: string = styles.subFAB;
  if (showSubFAB) {
    bgClassName = styles.background;
    mainButtonClassName = `${styles.mainButtonClicked} ${styles.mainButton}`;
    subFABLeftClassName += ` ${styles.subFABLeft}`;
    subFABLeftTopClassName += ` ${styles.subFABLeftTop}`;
    subFABTopClassName += ` ${styles.subFABTop}`;
  } else {
    bgClassName = styles.backgroundHidden;
    mainButtonClassName = styles.mainButton;
    subFABLeftClassName += ` ${styles.subFABLeftHidden}`;
    subFABLeftTopClassName += ` ${styles.subFABLeftTopHidden}`;
    subFABTopClassName += ` ${styles.subFABTopHidden}`;
  }

  return (
    <>
      {/* アクティブ時の半透明な背景 */}
      <div className={bgClassName} onClick={() => setShowSubFAB(false)}></div>
      {/* Floating Action Buttons */}
      <div className={styles.container}>
        <a
          className={mainButtonClassName}
          onClick={() => setShowSubFAB(!showSubFAB)}
        >
          ＋
        </a>

        <div className={styles.subFABContainer}>
          <a className={subFABLeftClassName} onClick={onClickLeft}>
            +
          </a>
          <a className={subFABLeftTopClassName} onClick={onClickLeftTop}>
            +
          </a>
          <a className={subFABTopClassName} onClick={onClickTop}>
            +
          </a>
        </div>
      </div>
    </>
  );
};

export default FloatingMenu;
